var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_vm._l((_vm.cart.parts),function(part){return _c('part',{key:'part-' + part.id,attrs:{"part":part,"reverse":_vm.reverse}})}),_vm._l((_vm.cart.letters),function(letter){return _c('letter',{key:'letter-' + letter.id,attrs:{"letter":letter,"reverse":_vm.reverse}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }